import React, { useContext } from 'react';
import { NewsletterSignup } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import { UserContext } from 'src/context/UserContext';
import { getAnalyticsAnonymousId } from 'src/utils/initializeFeatureGates';
import { getEnvironment } from 'src/services/http/user';

export const EmailSubscription: React.FC = () => {
  const data = useContext(UserContext);
  const user = data?.user;

  const anonymousId = getAnalyticsAnonymousId();
  const atlassianId = user?.account_id;

  return (
    <div id="subscribe" css={containerStyles} data-testid="email-subscription-section">
      <NewsletterSignup anonymousId={anonymousId} atlassianId={atlassianId} environment={getEnvironment()} />
    </div>
  );
};

const containerStyles = css({
  width: '100%',
  padding: `0 ${token('space.200')}`,
  marginTop: '104px',

  [media.below.md]: {
    marginTop: token('space.800'),
  },

  [media.below.sm]: {
    marginTop: token('space.600'),
  },
});
